<template>
<div> 
<div class="card" style="width: 98%; padding: 0.5em;top: 10px;left: 2px;">
          <h5 class="card-title">แนบไฟล์รูปใบเสร็จ/หลักฐานการชำระเงิน</h5>

          <p></p>

          <p></p>
           <div class="card-text">
            <div class="form-group">

              <input  ref="imageUploader"  type="file"  name="imageUploader"  @change="handlerUpload"
            accept="image/*" class="input-file">
            </div>
           
          </div>
          
        </div>
</div>
</template>
<script>
export default{
  props:{
      saleInfo:{
          type: Object
        }
    },
  data(){
    return {
      file:"",
      attachFileImage:""
    }
  },
  mounted(){
      console.log(this.saleInfo);
    },
  methods:{
     handlerUpload(e) {
      //console.log(this.$refs.imageUploader);
      console.log(e)
      // console.log(e.dataTransfer.files[0]);

      if (typeof e.target.files[0] === "undefined") {
        this.file = e;
      } else {
        this.file = e.target.files[0];
      }

      console.log(this.file);

      //this.dragdrop['FileValue'] = this.
      //if (this.isImage(this.file["name"])) {
        console.log("is image");
        this.createBase64Image(this.file);
      //} else {
      //  console.log("not image");
        //this.dragdrop["FileValue"] = "";
      //  this.attachFileImage = ""
      //}
      //console.log(this.dragdrop);

    },
    createBase64Image(file) {
      // let files = e.dataTransfer.files;
      console.log(file);
      console.log(typeof file)
      console.log(" create base64 ");

      // let f = files[0];
      let reader = new FileReader(file);

      reader.readAsDataURL(file);

      reader.onload = (e) => {
        console.log(e);
        //this.attachFileImage = e.target.result;
        //this.updateUpload();
        this.$emit("attachImage",{attachFile: e.target.result});
      };
      //console.log(this.attachFileImage);
      
    },
    isImage(attachment) {
      //
      let isImg = false;
      console.log(attachment);
      console.log(this.url);
      let imgExt = ["jpeg", "png", "gif", "jpg"];
      console.log(imgExt.length);
      for (let i = 0; i < imgExt.length; i++) {
        console.log(imgExt[i]);
        console.log(attachment);
        console.log(attachment.indexOf(imgExt[i]));
        if (attachment.indexOf(imgExt[i]) > -1) {
          isImg = true;
          // return "<img src=" + this.url + "/" + attachment + "  class='attachImg'>";
        }
      }
      return isImg;
    },
  }
}
</script>